import { create_c_z_record, delete_c_z_record, query_c_z_record_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-czrecord-config';
import { reactive } from 'vue';
import { get_is_delete, getDateTime, toFixed0 } from '@/utils/function';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'code',
        label: '充值编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写充值编号',
      },
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remoteselect',
        name: 'sk_type_id',
        label: '收款方式',
        disabled: false,
        placeholder: '请选择收款方式',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-sktype',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      {
        type: 'rangepicker',
        name: 'date_interval',
        label: '充值日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请选择充值日期',
      },
      // {
      //   type: 'remoteselect',
      //   name: 'shop_id',
      //   label: '执行门店',
      //   disabled: false,
      //   placeholder: '请选择执行门店',
      //   datasourceType: 'remote',
      //   mode: 'default',
      //   allowClear: true,
      //   modalType: 'mjstore-shop',
      // },
      {
        type: 'remoteselect',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        init_model: { shop_id: current_shop?.id },
        modalType: 'mjstore-staff',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      code: null,
      customer_id: null,
      staff_id: null,
      sk_type_id: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
    }),
  };
  const search_options = {
    is_active: [
      { value: None, name: '全部' },
      {
        value: True,
        name: '可用',
      },
      { value: False, name: '作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'input',
        name: 'price',
        label: '收款金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写收款金额',
      },
      {
        type: 'input',
        name: 'cz_flje',
        label: '返利金额',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写返利金额',
      },
      {
        type: 'remoteselect',
        name: 'sk_type_id',
        label: '收款方式',
        disabled: false,
        placeholder: '请选择收款方式',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-sktype',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      {
        type: 'datepicker',
        name: 'date',
        label: '充值日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD HH:mm:ss',
        valueFormat: 'YYYY-MM-DD HH:mm:ss',
        showTime: true,
        placeholder: '请选择充值日期',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remoteselect',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
      {
        type: 'remoteselect',
        name: 'doctor_ids',
        label: '治疗师',
        disabled: false,
        placeholder: '请选择治疗师',
        datasourceType: 'remote',
        mode: 'multiple',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
      {
        type: 'input',
        name: 'mark',
        label: '备注',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写备注',
      },
    ],
    rules: {
      price: [{ required: true, message: '请填输入充值金额' }],
      cz_flje: [{ required: true, message: '请填输入充值金额' }],
      customer_id: [{ required: true, message: '请填输入会员姓名' }],
      staff_id: [{ required: true, message: '请填输入执行人' }],
      date: [{ required: true, message: '请填输入充值日期' }],
      shop_id: [{ required: true, message: '请填输入执行门店' }],
      sk_type_id: [{ required: true, message: '请填选择收款方式' }],
      doctor_ids: [{ required: true, message: '请选择治疗师' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      customer_id: null,
      price: null,
      cz_flje: null,
      sk_type_id: null,
      cxzc_id: null,
      doctor_ids: null,
      staff_id: null,
      date: null,
      mark: null,
      shop_id: current_shop?.id,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '充值记录管理',
    addModalTitle: '新建',
    updateTitle: '修改',
    del_btn: '作废',
    is_create: true, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      czrecord_id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '充值编号',
      width: 180,
      dataIndex: 'code',
      checked: true,
    },
    {
      title: '会籍门店',
      width: 150,
      dataIndex: 'customer__shop__name',
      checked: true,
    },
    {
      title: '会员编号',
      width: 140,
      dataIndex: 'customer__code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'customer__name',
      checked: true,
    },
    {
      title: '收款金额',
      dataIndex: 'price',
      width: 90,
      checked: true,
      content: (record: any, text: any) => {
        return parseInt(text);
      },
    },
    {
      title: '返利金额',
      dataIndex: 'cz_flje',
      width: 90,
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '促销政策',
      dataIndex: 'cxzc__name',
      width: 120,
      checked: true,
    },
    {
      title: '支付方式',
      dataIndex: 'sk_type__name',
      width: 100,
      checked: true,
    },
    {
      title: '备注',
      dataIndex: 'mark',
      width: 90,
      checked: true,
    },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'customer__adviser__name',
      checked: true,
    },
    {
      title: '执行门店',
      dataIndex: 'shop__name',
      width: 140,
      checked: true,
    },
    {
      title: '执行人',
      dataIndex: 'staff__name',
      width: 90,
      checked: true,
    },
    {
      title: '治疗师',
      dataIndex: 'doctor_json_data',
      width: 200,
      checked: true,
      cellComponent: 'list',
    },
    {
      title: '充值日期',
      width: 135,
      dataIndex: 'date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },

    {
      title: '创建日期',
      width: 135,
      dataIndex: 'create_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '单据状态',
      width: 110,
      dataIndex: 'is_active',
      checked: true,
      cellComponent: 'boolean',
      name1: '未作废',
      name2: '已作废',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '未作废', value: true },
        { text: '已作废', value: false },
      ],
      content: (record: any, text: any) => {
        const dict: any = {
          true: '未作废',
          false: '已作废',
        };
        return dict[text];
      },
    },
    {
      title: '确认日期',
      width: 135,
      dataIndex: 'receipt_datetime',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 130,
      fixed: 'right',
      checked: true,
      cellComponent: 'action',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_delete',
    field_true: '未作废',
    field_false: '已作废',
  });

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_c_z_record_list,
    addData: create_c_z_record,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
